import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {OrganisationUser} from '../models/models.lib';
import {ApiService} from '../api/api.service';

const { apiUrl } = environment;

export abstract class CasiOrganisationUserService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(organisationId: number): void {
    this.fetch(organisationId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(organisationId: number): Observable<OrganisationUser[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/organisation/user/all/${organisationId}`))
      .pipe(
        map((response: any, i) => {
          return <OrganisationUser[]>response;
        }),
        map(r => r.map(x => OrganisationUser.create(x))),
        tap(() => (this.loading = false))
      )
  }
}


@Injectable({
  providedIn: 'root'
})
export class OrganisationUserService extends CasiOrganisationUserService {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(organisationId: number) {
    return this.apiService.getHttpCall(`organisation/user/all/${organisationId}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('organisation/user', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`organisation/user/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`organisation/user/${id}` , 'destroy');
  }
}
